// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"b079f53c","312":"80ed1466","339":"b4288a08","424":"64b86cdb","457":"a0dafd1f","551":"5585ccdb","682":"e7dfb3fb","828":"59d69fe7","842":"6f1fca5f","904":"bc1e9108","944":"173ee4a3","950":"f115d21d","965":"189b08ac"}[chunkId] + ".chunk.js";
};